var _circle, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3286 24.3568V25.6702C12.3286 26.0387 12.6273 26.3373 12.9957 26.3373H14.3092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3092 13.6627H12.9957C12.6273 13.6627 12.3286 13.9614 12.3286 14.3298V15.6433"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6715 15.6433V14.3298C27.6715 13.9614 27.3728 13.6627 27.0044 13.6627H25.6909"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6909 26.3373H27.0044C27.3728 26.3373 27.6715 26.0387 27.6715 25.6702V24.3568"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6621,
    y: 15.6639,
    width: 2.00125,
    height: 2.00125
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.333,
    y: 15.6639,
    width: 2.00125,
    height: 2.00125
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6621,
    y: 22.3348,
    width: 2.00125,
    height: 2.00125
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.333 22.3348V24.336H24.3343V22.3348H23.6672"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9976 17.3316V15.6639H20.9988"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9985 16.9981V19.3329"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6621 21.0007H18.9975V19.3329"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9976 22.3348V24.336H20.9988"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3315 22.3348H20.9986"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6621 18.9994H17.6634"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3343 18.9994H22.333V19.6665"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3315 21.0006H24.334"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.a71187ad.svg";
export { ForwardRef as ReactComponent };